import React from 'react';
import { useStyletron } from 'baseui';
import { useAtomValue, useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { useEnableRemainingItemsM3Panel } from '../../../common/hooks/use-enable-remaining-items-m3-panel';
import { TASK_MODE } from '../../../common/task-state/constants';
import useTaskStateStore from '../../../common/task-state/providers/hooks/useTaskStateStore';
import { useRelationshipsEnabled } from '../../../image/labelling-v2/hooks/use-relationships-enabled';
import { drawerAtom } from '../atoms/drawer.atom';
import { ActionHeader, STATUS_TYPE } from '../common';
import { useMLAnnotations } from '../hooks/use-ml-annotations';
import { usePendingAnnotations } from '../hooks/use-pending-annotations';
import { useMLAnnotationsDrawer } from '../ml-annotations/use-ml-annotations-drawer';
import { usePendingAnnotationDrawer } from '../pending-annotation/use-pending-annotation-drawer';
import { useSidePanel } from '../side-panel-provider';
import { shouldShowMLAnnotations } from '../utils/get-should-show-ml-annotations';
import { AnnotationList } from './annotation-list';
const RELATIONSHIP_PROPS = {
  title: () => 'Relationships',
  description: ''
};
export const AnnotationsPanel = () => {
  const {
    hasRequiredTaskMode
  } = useTaskStateStore();
  const shouldShowRemainingItems = !hasRequiredTaskMode(TASK_MODE.REVIEW);
  const isRemainingItemsSidePanelM3Enabled = useEnableRemainingItemsM3Panel(shouldShowRemainingItems);
  const [css, theme] = useStyletron();
  const {
    annotationFilterComponent,
    relationshipComponent,
    numAnnotationFramesAtom
  } = useSidePanel();
  const {
    pendingMLAnnotations
  } = useMLAnnotations();
  const pendingAnnotations = usePendingAnnotations();
  const setDrawer = useSetAtom(drawerAtom);
  const {
    openPendingItemDrawer
  } = usePendingAnnotationDrawer();
  const {
    open: openMLAnnotationsDrawer
  } = useMLAnnotationsDrawer();
  const numFrames = useAtomValue(numAnnotationFramesAtom);
  const isNewRelationshipsFeatureEnabled = useRelationshipsEnabled();
  const showMLAnnotations = shouldShowMLAnnotations(numFrames, pendingMLAnnotations);
  const sectionStyle = css({
    overflow: 'auto',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column'
  });
  const titleStyle = css({
    paddingBottom: theme.sizing.scale600,
    ...theme.typography.LabelLarge,
    flexShrink: 0
  });
  const contentStyle = css({
    paddingBottom: theme.sizing.scale400,
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  });
  const actionHeaderWrapperStyle = css({
    flexBasis: '15%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  });
  const closeRelationship = () => {
    relationshipComponent?.onClose?.();
    setDrawer(RESET);
  };
  const openRelationshipModel = () => {
    setDrawer({
      ...RELATIONSHIP_PROPS,
      onClose: closeRelationship,
      component: ({
        onClose
      }) => relationshipComponent?.Component?.({
        onClose
      }),
      isOpen: true
    });
  };
  return <div className={css({
    paddingTop: theme.sizing.scale800,
    display: 'flex',
    justifyContent: 'space-between',
    height: `calc(100% - ${theme.sizing.scale800})`,
    flexDirection: 'column'
  })}>
      {/* Objects Section */}
      <div className={sectionStyle}>
        {annotationFilterComponent && <div className={titleStyle}>{annotationFilterComponent?.()}</div>}
        <div className={contentStyle}>
          <AnnotationList />
        </div>
      </div>
      <div className={actionHeaderWrapperStyle}>
        {pendingAnnotations.length > 0 && !isRemainingItemsSidePanelM3Enabled && <ActionHeader title="Pending items" status={STATUS_TYPE.WARNING} onActionClick={() => openPendingItemDrawer()} statusText={`${pendingAnnotations.length} remaining`} />}
        {showMLAnnotations && <ActionHeader title="ML Annotations" status={STATUS_TYPE.OPTIONAL} onActionClick={() => openMLAnnotationsDrawer()} statusText={`${pendingMLAnnotations.length} remaining`} />}
        {relationshipComponent && !isNewRelationshipsFeatureEnabled && <ActionHeader title="Relationships" status={relationshipComponent?.status} onActionClick={() => {
        relationshipComponent.onOpen?.();
        openRelationshipModel();
      }} />}
      </div>
    </div>;
};